<template>
    <v-layout row wrap>
        <v-flex class="xs12 _nav--item hidden-sm-and-up">
            <router-link to="/inbox" class="link-small">
                <div class="text-xs-center _nav--item__content">
                    <v-badge class="_nav-badge--dashboard">
                        <app-svg-icon name="brand/NG_INBOX" width="50"></app-svg-icon>
                        <span v-if="unreadMsg"
                                  slot="badge">{{unreadMsg}}</span>
                    </v-badge>
                    <span class="d-block _nav--name">Inbox</span>
                </div>
            </router-link>
        </v-flex>
        <v-flex v-for="item in computedItems"
                :key="item.icon"
                @click="clickevent(item.id)"
                class="xs6 sm4 _nav--item">
            <router-link :to="item.path"
                         :class="`link-small ${item.class}`">
                <div @click="activity_log(item.log_name)" class="text-xs-center _nav--item__content">
                    <v-badge class="_nav-badge--dashboard">
                        <app-svg-icon :name="`brand/${item.icon}`"></app-svg-icon>
                        <span v-if="item.count"
                              slot="badge">{{item.count}}</span>
                    </v-badge>
                    <span class="d-block _nav--name">{{item.name}}</span>
                </div>
            </router-link>
        </v-flex>
    </v-layout>
</template>

<script>
import logActivity from '../../../../util/activitylog';


  export default {
    name: 'dashboard-navbar',
    
    created() {
      if (this.$auth.user().role === 'nanny') {
        this.$store.dispatch('notifications/GET_NEW_JOBS_COUNT')
      }
    }
    ,
    computed: {
      unreadMsg () {
        return this.$store.getters['notifications/messages']
      },  
      items () {
        const expired = this.$auth.user().role === 'parent' && (this.$auth.user().subscription ? this.$auth.user().subscription.ended : null)
        if(this.$auth.user().is_subscribe==1){
          var textinfodata = "Unsubscribe from NannyGranny updates";
        }else{
          var textinfodata = "Subscribe to NannyGranny email";
        }
        return [
          {
            name: 'My Favourites',
            path: '/favourites',
            icon: 'NG_FAVOURITES',
            auth: ['parent', 'nanny'],
            // count: this.$store.getters['notifications/favourites']
           // class: (expired ? 'subscription-expired' : ''),
            log_name: 'fav'
          }, {
            name: 'My Connections',
            path: '/connections',
            icon: 'NG_CONNECTIONS',
            auth: [],
            count: this.$store.getters['notifications/connections'],
            log_name: ''
          }, {
            name: 'My Clubs',
            path: '/favourites',
            icon: 'NG_CLUB_HOUSE',
            auth: [],
            count: this.$store.getters['notifications/clubs'],
            log_name: 'clubhouse'
          }, {
            name: 'Post a job',
            path: '/job-post',
            icon: 'NG_POST_A_JOB',
            auth: ['parent'],
            class: (expired ? 'subscription-expired' : ''),
            log_name:'job',
          }, {
            name: 'My Reviews',
            path: '/reviews',
            icon: 'NG_REVIEWS',
            auth: ['parent', 'nanny'],
            count: 0,
            class: (expired ? 'subscription-expired' : ''),
            log_name:'reviews'
          }, {
            name: 'My Account',
            path: '/account',
            icon: 'NG_MY_ACCOUNT',
            auth: ['parent', 'nanny'],
            log_name:'account'
          },
          
           {
            name: 'My Membership',
            path: '/subscription',
            icon: 'NG_SUBSCRIPTION',
            auth: ['parent'],
            log_name:'membership'
          },{
            name: textinfodata,
            path: '/dashboard',
            icon: 'NG_SUBSCRIPTION',
            id:"unsub",
            auth: ['parent', 'nanny'],
            class: ('check-subscription-expired'),
            log_name:''
          },
          {
            name: 'New Job Posts',
            path: '/new-job-post',
            icon: 'vector',
            auth: [ 'nanny'],
            count: this.$store.getters['notifications/newjobposts'],
            log_name:'job'
          },
        ]
      },
      computedItems () {
        let role = this.$auth.user().role
        return this.items.filter((item) => item.auth.indexOf(role) > -1)
      },
    },
    methods: {
        clickevent (event) {
          if(event=='unsub'){
            if(this.$auth.user().is_subscribe==1){
              var textsub = 'unsubscribe';
              var pass_status = 0;
            }else{
              var textsub = 'subscribe';
              var pass_status = 1;
            }
            if(textsub == 'unsubscribe'){ // confirmation popup for unsubscribe option only
              if(confirm("Are you sure you want to "+textsub+" from non essential mails?")){
                this.$store.dispatch('unsubscribe/UNSUBSCRIBE_STORE', {user_id: this.$auth.user().id,status :pass_status}).then(data => {
                  if(textsub == 'unsubscribe'){
                    var msg_alert = 'You have been unsubscribed from NannyGranny’s non essential emails. Don’t worry, we’ll still send you important account updates.';
                  }else{
                    var msg_alert = 'Thank you for Subscribing to NannyGranny emails';
                  }
                  this.showSnackBar(msg_alert, 'error')
                  location.reload()
                }).catch(() => (alert('There is an error. Please try again')))
              }
            }else{
              this.$store.dispatch('unsubscribe/UNSUBSCRIBE_STORE', {user_id: this.$auth.user().id,status :pass_status}).then(data => {
                if(textsub == 'unsubscribe'){
                  var msg_alert = 'You have been unsubscribed from NannyGranny’s non essential emails. Don’t worry, we’ll still send you important account updates.';
                }else{
                  var msg_alert = 'Thank you for Subscribing to NannyGranny emails';
                }
                this.showSnackBar(msg_alert, 'error')
                location.reload()
              }).catch(() => (alert('There is an error. Please try again')))
            }
          }
        },
        activity_log(log_name){          
          if(log_name !== ''){
            logActivity(log_name);
          }
        }
      }
  }
</script>

<style lang="stylus" scoped>
    ._nav
        &--item
            height 140px
            border-bottom 1px solid var(--grey_2)
            &:nth-child(2n)
                border-right 1px solid var(--grey_2)
            a
                color var(--blue)
                text-decoration none
                &:hover
                    color var(--blue_hover)
            .svg-icon
                width 42px
                height 60px
        &--name
            margin-top 16px

    @media (max-width: 599px)
        ._nav
            &--item__content
                padding-top 12px

    @media (min-width: 600px)
        ._nav
            &--item
                height 190px
                border-bottom none
                &:nth-child(2n)
                    border-right none
                a
                    text-decoration none
                .svg-icon
                    width 66px
                    height 80px
            &--name
                margin-top 30px
</style>



// WEBPACK FOOTER //
// src/views/app/dashboard/components/dashboard-navbar.vue